function allowCookies() {
  document.cookie = "allow_cookies=yes; max-age=" + 365 * 24 * 60 * 60 + "; path=/"; // Set cookie for 365 days
  const cookiesBanner = document.getElementById('cookies');
  if (cookiesBanner) {
    cookiesBanner.style.transition = "opacity 0.5s"; // Smooth fade-out effect
    cookiesBanner.style.opacity = "0";
    setTimeout(() => cookiesBanner.remove(), 500); // Remove element after fade-out
  }
}

// Function to set the locale
function setLocale(langCode) {
  document.cookie = "locale=" + langCode + "; max-age=" + 365 * 24 * 60 * 60 + "; path=/"; // Set locale cookie for 365 days
}

export default function changingCookiesAndLocale() {
  const acceptCookiesButton = document.getElementById('accept-cookies');
  const plCookieButton = document.getElementById('pl-cookie');
  const enCookieButton = document.getElementById('en-cookie');

  if (acceptCookiesButton) {
    acceptCookiesButton.addEventListener('click', (e) => {
      allowCookies();
    });
  }

  if (plCookieButton) {
    plCookieButton.addEventListener('click', (e) => {
      setLocale('pl');
    });
  }

  if (enCookieButton) {
    enCookieButton.addEventListener('click', (e) => {
      setLocale('en');
    });
  }
}